import { b as n, G as d } from "../../base-BUIxijjU.js";
import { useEffect as c } from "react";
import "react/jsx-runtime";
import "../../index-C7ezJk5b.js";
import "react-dom";
import '../../assets/Wrapper.css';/* empty css                     */
import "react-router-dom";
function g() {
  const {
    appId: m,
    userInfo: o,
    isUserInfoLoaded: t
  } = n();
  c(() => {
    const {
      gtmId: a,
      id: i,
      companyName: e,
      companyId: r,
      products: p
    } = o;
    if (t) {
      const s = p[m].gtmToolName;
      d.initialize({
        gtmId: a,
        dataLayer: {
          user_id: i,
          company: e,
          company_id: r,
          tool: s
        }
      });
    }
  }, [t, o]);
}
export {
  g as default
};
